import { AbstractLoadingView } from './AbstractLoadingView';
import klass from './MarppleShopLoading.module.scss';

export class MarppleShopLoadingView extends AbstractLoadingView {
  constructor(initial_active?: boolean) {
    super({
      container_klass: klass.loading_container,
      loading_klass: klass.img,
      hidden_klass: klass.hidden,
    });
    this.active = initial_active ?? false;
  }

  public show() {
    this.setActive(true);
    this.setElementVisibility(true);
  }

  public hide() {
    this.setActive(false);
    this.setElementVisibility(false);
  }
}
